const imagenes2 = document.querySelectorAll('.galeria .contenedor-imagen');
const imagenModal1 = document.getElementById('imagen-modal1');
const imagenModal2 = document.getElementById('imagen-modal2');
const imagenModal3 = document.getElementById('imagen-modal3');

imagenes2.forEach((imagen2) => {
    imagen2.addEventListener('click', () => {
        const ruta2 = imagen2.querySelector('img').src;
        imagenModal1.src = ruta2;
        //let part = ruta2.slice(10,16)
        let parte = ruta2.replace(/image/, "image1")
        //console.log(parte);
        imagenModal2.src = parte;
        let parte2 = parte.replace(/image1/, "image2")
        imagenModal3.src = parte2;
            
    });
 });

 